export default __webpack_public_path__ + "static/media/01_MINE_01-min.f5797848.jpg";